  const lenis = new Lenis()

  lenis.on('scroll', (e) => {
    // console.log(e)
  })

  lenis.on('scroll', ScrollTrigger.update)

  gsap.ticker.add((time)=>{
    lenis.raf(time * 1000)
  })

  gsap.ticker.lagSmoothing(0)


jQuery(document).ready(function($) {
        $(window).scroll(function() {
        var scrollPos = $(window).scrollTop(),
           navbar = $('.header-wrapper');
        
        if (scrollPos > 80) {
         navbar.addClass('active-header');
        } else {
         navbar.removeClass('active-header');
        }
        });
        });

 // let bgImages = document.querySelectorAll(".scroll-img-container");

 //    bgImages.forEach(bgImage  => {
 //            gsap.registerPlugin(ScrollTrigger);

 //            gsap.fromTo(
 //                bgImage,
 //                {
 //                    clipPath: "circle(5% at 50% 50%)",
 //                },
 //                {
 //                    clipPath: "circle(75% at 50% 50%)",
 //                    ease: "none",
 //                    scrollTrigger: {
 //                        trigger: bgImage,
 //                        scrub: 1,
 //                        start: "top 60%",
 //                        end: "top center-=200",
 //                    },
 //                }
 //            );
 //        })


gsap.registerPlugin(ScrollTrigger);
gsap.set(".loader", {
  opacity: 1,
  duration: 1,
  ease: Power3.easeOut });

// /up
// let reveal_text = document.querySelectorAll(".reveal_up , .jdgm-carousel-wrapper");

// reveal_text.forEach(container => {
//   let image = container.querySelector("img");
//   let tl = gsap.timeline({
//     scrollTrigger: {
//       trigger: container,
//       toggleActions: "restart none none reset"
//     } });
      


//   tl.set(container, { autoAlpha: 1 });
//   tl.from(container, 1.5, {
//     yPercent: 100,
//     ease: Power2.out });

//   tl.from(image, 1.5, {
//     yPercent: -100,
//     scale: 1.3,
//     delay: -1.5,
//     ease: Power2.out });

// });
// // left to right

gsap.registerPlugin(ScrollTrigger);
  
let revealContainers = document.querySelectorAll(".reveal");

revealContainers.forEach(container => {
  let image = container.querySelector("img");
  let tl = gsap.timeline({
    scrollTrigger: {
      trigger: container,
      toggleActions: "restart none none reset" } });



  tl.set(container, { autoAlpha: 1 });
  tl.from(container, 1.5, {
    xPercent: -100,
    ease: Power2.out });

  tl.from(image, 1.5, {
    xPercent: 100,
    scale: 1.3,
    delay: -1.5,
    ease: Power2.out });

});
// footer contact
var footer_block= document.querySelectorAll(".footer-block");
var footer_block_last = footer_block[3];
 var footer_block_lastchild =footer_block_last.lastElementChild;
 var footer_block_firstchild =footer_block_last.firstElementChild;
footer_block_firstchild.classList.add("active");
footer_block_lastchild.style.display= "block";